module.exports = __webpack_public_path__ + "static/media/728x90_0016_ru.530a5faf.jpg";